import { ParkingDashboard } from "../components/ParkingDashboard";
import { getParkingData } from "../lib/parkingDataSource";

const parkingData = getParkingData();

export default function DashboardPage() {
  return <ParkingDashboard parkingData={parkingData} />;
}
